import { Box, Typography, TableCell, CardMedia } from "@mui/material";
import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";
// import { getDimensions } from "@/utils/product/getDimensions";

export const ROWS = {
  image: "image",
  name: "name",
  price: "price",
  shortDescription: "shortDescription",

  // gpsModule: "gpsModule",
  // gpsModuleTitle: "gpsModuleTitle",
  // voltage: "voltage",
  // voltageTitle: "voltageTitle",
  // sizeImperial: "sizeImperial",
  // sizeMetric: "sizeMetric",
};

export const compareRows = [
  ROWS.image,
  ROWS.name,
  ROWS.price,
  ROWS.shortDescription,
  // ROWS.gpsModule,
  // ROWS.gpsModuleTitle,
  // ROWS.voltage,
  // ROWS.voltageTitle,
  // ROWS.sizeImperial,
  // ROWS.sizeMetric,
];

export const renderRow = (
  rowKey: string,
  compareProducts: ISimilarProduct[]
) => {
  const numColumns = compareProducts.length; // columns
  const cellWidth = `${100 / numColumns}%`; // table cell width
  const cellpx = { xs: 1.5, md: 2, lg: 3, xl: 7 }; // padding for table cell

  switch (rowKey) {
    case ROWS.image:
      return compareProducts.map((product) => (
        <TableCell
          key={product.id}
          style={{ width: cellWidth }}
          sx={{ pb: { xs: 3, md: 6, lg: 10.5 }, px: cellpx }}
        >
          <Box
            boxSizing="border-box"
            width={{ xs: 176, md: 165 }}
            height={{ xs: 176, md: 165 }}
            mx="auto"
          >
            <CardMedia
              component="img"
              image={product.image}
              alt={product.name}
              width="100%"
              height="100%"
              sx={{ objectFit: "contain" }}
            />
          </Box>
        </TableCell>
      ));
    case ROWS.name:
      return compareProducts.map((product) => (
        <TableCell
          key={product.id}
          style={{ width: cellWidth }}
          sx={{ px: cellpx, pt: 2, pb: { xs: 2, md: 3, lg: 3, xl: 7 } }}
        >
          <Typography
            variant="h5"
            component="p"
            fontFamily={{ xs: FONT_SECONDARY, md: FONT_PRIMARY }}
            fontSize={{ xs: "1rem", md: "1.5rem" }}
            textAlign="center"
          >
            {product.name}
          </Typography>
        </TableCell>
      ));
    case ROWS.price:
      return compareProducts.map((product) => (
        <TableCell
          key={product.id}
          style={{ width: cellWidth }}
          sx={{ pt: 0, pb: { xs: 3, md: 5 }, px: cellpx }}
        >
          <Typography variant="h5" component="p" textAlign="center">
            ${product.price}
          </Typography>
        </TableCell>
      ));
    case ROWS.shortDescription:
      return compareProducts.map((product) => (
        <TableCell
          key={product.id}
          style={{ width: cellWidth }}
          sx={{ pt: 0, pb: { xs: 3, md: 6.5 }, px: cellpx }}
        >
          <Typography
            variant="body1"
            component="p"
            fontSize={"1rem"}
            color="text.secondary"
            textAlign="center"
            dangerouslySetInnerHTML={{ __html: product.shortDescription }}
          ></Typography>
        </TableCell>
      ));
    // case ROWS.gpsModule:
    //   return compareProducts.map((product) => (
    //     <TableCell
    //       key={product.id}
    //       style={{ width: cellWidth }}
    //       sx={{ pt: 0, pb: { xs: 1, md: 2 }, px: cellpx }}
    //     >
    //       <Typography
    //         variant="h5"
    //         component="p"
    //         textTransform="uppercase"
    //         textAlign="center"
    //         fontFamily={{ xs: FONT_SECONDARY, md: FONT_PRIMARY }}
    //         fontSize={{ xs: "1rem", md: "1.25rem" }}
    //       >
    //         {product.gpsModule}
    //       </Typography>
    //     </TableCell>
    //   ));
    // case ROWS.gpsModuleTitle:
    //   return compareProducts.map((product) => (
    //     <TableCell
    //       key={product.id}
    //       style={{ width: cellWidth }}
    //       sx={{ pt: 0, pb: { xs: 4, md: 5 }, px: cellpx }}
    //     >
    //       <Typography
    //         variant="body2"
    //         component="p"
    //         textAlign="center"
    //         fontWeight={{ xs: 700, md: 600 }}
    //       >
    //         GPS Module
    //       </Typography>
    //     </TableCell>
    //   ));
    // case ROWS.voltage:
    //   return compareProducts.map((product) => (
    //     <TableCell
    //       key={product.id}
    //       style={{ width: cellWidth }}
    //       sx={{ pt: 0, pb: { xs: 1, md: 2 }, px: cellpx }}
    //     >
    //       <Typography
    //         textAlign="center"
    //         variant="h5"
    //         component="p"
    //         textTransform="uppercase"
    //         fontFamily={{ xs: FONT_SECONDARY, md: FONT_PRIMARY }}
    //         fontSize={{ xs: "1rem", md: "1.25rem" }}
    //       >
    //         {product.voltage}
    //       </Typography>
    //     </TableCell>
    //   ));
    // case ROWS.voltageTitle:
    //   return compareProducts.map((product) => (
    //     <TableCell
    //       key={product.id}
    //       style={{ width: cellWidth }}
    //       sx={{ pt: 0, pb: { xs: 3, md: 7 }, px: cellpx }}
    //     >
    //       <Typography
    //         variant="body2"
    //         component="p"
    //         textAlign="center"
    //         fontWeight={{ xs: 700, md: 600 }}
    //         textTransform={{ xs: "uppercase", md: "capitalize" }}
    //       >
    //         Usage
    //       </Typography>
    //     </TableCell>
    //   ));
    // case ROWS.sizeImperial:
    //   return compareProducts.map((product) => (
    //     <TableCell
    //       key={product.id}
    //       style={{ width: cellWidth }}
    //       sx={{ pt: 0, pb: { xs: 0.5, md: 1 }, px: cellpx }}
    //     >
    //       <Typography
    //         textAlign="center"
    //         variant="body1"
    //         component="p"
    //         color="text.secondary"
    //       >
    //         {getDimensions(product?.dimension)?.imperial}
    //       </Typography>
    //     </TableCell>
    //   ));
    // case ROWS.sizeMetric:
    //   return compareProducts.map((product) => (
    //     <TableCell
    //       key={product.id}
    //       style={{ width: cellWidth }}
    //       sx={{ pt: 0, pb: { xs: 6, md: 9.75 }, px: cellpx }}
    //     >
    //       <Typography
    //         variant="body1"
    //         component="p"
    //         color="text.secondary"
    //         textAlign="center"
    //       >
    //         {getDimensions(product?.dimension)?.metric}
    //       </Typography>
    //     </TableCell>
    //   ));
    default:
      return null;
  }
};
